<template>
  <div class="bigImage" @click="bigImage">
    <div class="image" :style="`background-image: url('${image}')`"></div>
    <a v-if="$mq === 'small'" class="info">Dotknij gdziekolwiek, aby wyłączyć podgląd.</a>
    <a class="info" v-else>Kliknij gdziekolwiek, aby wyłączyć podgląd.</a>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  computed:{
    ...mapState({
      image: state=>state.compress.currentImage.url
    })
  },
  methods:{
      ...mapMutations(['bigImage'])
  }
}
</script>

<style scoped lang="scss">
.info{
  color: rgba(255, 255, 255, 0.651);
  position: absolute;
  bottom: 12px;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 9999;
}
.bigImage{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.74);
  display: flex;
  justify-content: center;
  align-items: center;
}
.image{
  width: 100%;
  height: 300px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  z-index: 999;
}
@media (min-width: 440px){
  .image{
    width: 100%;
    height: 90%;
    background-size: 90%;
  }
}
@media (min-width: 740px){
  .image{
    width: 100%;
    height: 90%;
    background-size: 90%;
  }
}
@media (min-width: 1024px){
  .image{
    width: 100%;
    height: 80%;
    background-size: 80%;
  }
}
@media (min-width: 1524px){
  .image{
    width: 100%;
    height: 90%;
    background-size: 75%;
  }
}
</style>